import React, { FunctionComponent } from "react";

import CallToAction from "../callToAction";
import CodeBlock from "../codeBlock";
import TextSection from "../textSection";
import Video from "../video";
import HeroSection from "../heroSection";
import ContentSection from "../contentSection";
import Statistics from "../statistics";
import IconWithText from "../iconWithText";
import TeamMember from "../teamMember";
import ComponentCollection from "../componentCollection";
import HubspotForm from "../form/hubspotForm";
import NewsletterSignup from "../newsletterSignup";
import { BlogPostTile } from "../blogLayout/blogPostTitle";
import BlogPosts from "../blogPosts";
import List from "../list";
import PropertySearch from "../propertySearch";
import PricingPlan from "../pricingPlan";
import Report from "../report";

type BlockProps = {
  block: any;
  contentSection?: boolean;
  preventCircularDep?: boolean;
  richText?: boolean;
  topLevel?: boolean;
};

const Block: FunctionComponent<BlockProps> = ({
  block,
  contentSection = false,
  preventCircularDep = false,
  richText = false,
  topLevel = false,
}) => {
  const Components = {
    blogPosts: BlogPosts,
    callToAction: CallToAction,
    codeBlock: CodeBlock,
    textSection: TextSection,
    video: Video,
    heroSection: HeroSection,
    contentSection: ContentSection,
    statistics: Statistics,
    iconWithText: IconWithText,
    list: List,
    teamMember: TeamMember,
    componentCollection: ComponentCollection,
    propertySearch: PropertySearch,
    pricingPlan: PricingPlan,
    report: Report,
    ...(!preventCircularDep && { hubspotForm: HubspotForm }),
    blog: BlogPostTile,
    ...(!preventCircularDep && { newsletterSignup: NewsletterSignup }),
  };
  // component does exist
  if (
    typeof Components[block.sys.contentType.sys.id as keyof Object] !==
    "undefined"
  ) {
    const element = React.createElement(
      Components[block.sys.contentType.sys.id as keyof Object] as any,
      {
        key: block.sys.id,
        content: block,
        contentSection: contentSection,
        richText: richText,
        topLevel: topLevel,
      },
    );
    return (
      <div
        className="scroll-mt-20"
        id={`${block.sys.contentType.sys.id}-${block.sys.id}`}
      >
        {element}
      </div>
    );
  }
  // component doesn't exist yet
  return React.createElement(() => <></>, { key: block.sys.id });
};

export default Block;
